//Action creator
export const toggleSplashscreen = (splashShouldShow) => {
  //return an action
  return {
    type: "SET_SHOW_SPLASHSCREEN",
    payload: splashShouldShow,
  };
};
